import { SHIPMENT_SOLUTION_TYPES } from "~/cores/shipment.core";
import { createMockProduct, createProductsAndExchangeToProductsFn, createReturnReasonConfigStuff } from "../mockCore";

const productData1 = {
    product: createMockProduct({
        id: 1,
        productName: "BOXY JACKET",
        imageSrc: "/mocks/BOXY-DOUBLE-FACED-WOOL-JACKET-Light-grey.jpeg",
        purchasePrice: 1500,
        properties: [
            {
                type: "Color",
                value: "LIGHT GREY",
            },
            {
                type: "Size",
                value: "S",
            },
        ],
    }),
    exchangeToProductsData: {
        originalProductVariants: [
            {
                inventoryTurnr: 0,
                inventoryMerchant: 1,
                properties: [
                    {
                        type: "Color",
                        value: "LIGHT GREY",
                    },
                    {
                        type: "Size",
                        value: "XS",
                    },
                ],
            },
            {
                inventoryTurnr: 0,
                inventoryMerchant: 1,
                properties: [
                    {
                        type: "Color",
                        value: "LIGHT GREY",
                    },
                    {
                        type: "Size",
                        value: "M",
                    },
                ],
            },
            {
                inventoryTurnr: 0,
                inventoryMerchant: 0,
                properties: [
                    {
                        type: "Color",
                        value: "LIGHT GREY",
                    },
                    {
                        type: "Size",
                        value: "L",
                    },
                ],
            },
            {
                inventoryTurnr: 0,
                inventoryMerchant: 1,
                imageSrc: "/mocks/BOXY-DOUBLE-FACED-WOOL-JACKET-navy.jpeg",
                properties: [
                    {
                        type: "Color",
                        value: "NAVY",
                    },
                    {
                        type: "Size",
                        value: "XXS",
                    },
                ],
            },
            {
                inventoryTurnr: 0,
                inventoryMerchant: 1,
                imageSrc: "/mocks/BOXY-DOUBLE-FACED-WOOL-JACKET-navy.jpeg",
                properties: [
                    {
                        type: "Color",
                        value: "NAVY",
                    },
                    {
                        type: "Size",
                        value: "XS",
                    },
                ],
            },
            {
                inventoryTurnr: 0,
                inventoryMerchant: 1,
                imageSrc: "/mocks/BOXY-DOUBLE-FACED-WOOL-JACKET-navy.jpeg",
                properties: [
                    {
                        type: "Color",
                        value: "NAVY",
                    },
                    {
                        type: "Size",
                        value: "S",
                    },
                ],
            },
            {
                inventoryTurnr: 0,
                inventoryMerchant: 1,
                imageSrc: "/mocks/BOXY-DOUBLE-FACED-WOOL-JACKET-navy.jpeg",
                properties: [
                    {
                        type: "Color",
                        value: "NAVY",
                    },
                    {
                        type: "Size",
                        value: "M",
                    },
                ],
            },
            {
                inventoryTurnr: 0,
                inventoryMerchant: 1,
                imageSrc: "/mocks/BOXY-DOUBLE-FACED-WOOL-JACKET-navy.jpeg",
                properties: [
                    {
                        type: "Color",
                        value: "NAVY",
                    },
                    {
                        type: "Size",
                        value: "L",
                    },
                ],
            },
            {
                inventoryTurnr: 0,
                inventoryMerchant: 1,
                imageSrc: "/mocks/BOXY-DOUBLE-FACED-WOOL-JACKET-black.jpeg",
                properties: [
                    {
                        type: "Color",
                        value: "BLACK",
                    },
                    {
                        type: "Size",
                        value: "XS",
                    },
                ],
            },
            {
                inventoryTurnr: 0,
                inventoryMerchant: 1,
                imageSrc: "/mocks/BOXY-DOUBLE-FACED-WOOL-JACKET-black.jpeg",
                properties: [
                    {
                        type: "Color",
                        value: "BLACK",
                    },
                    {
                        type: "Size",
                        value: "S",
                    },
                ],
            },
            {
                inventoryTurnr: 0,
                inventoryMerchant: 1,
                imageSrc: "/mocks/BOXY-DOUBLE-FACED-WOOL-JACKET-black.jpeg",
                properties: [
                    {
                        type: "Color",
                        value: "BLACK",
                    },
                    {
                        type: "Size",
                        value: "M",
                    },
                ],
            },
            {
                inventoryTurnr: 0,
                inventoryMerchant: 1,
                imageSrc: "/mocks/BOXY-DOUBLE-FACED-WOOL-JACKET-black.jpeg",
                properties: [
                    {
                        type: "Color",
                        value: "BLACK",
                    },
                    {
                        type: "Size",
                        value: "L",
                    },
                ],
            },
        ],
    },
    similarProducts: [
        {
            actualProductId: 982,
            productName: "OVERSIZED JACKET",
            imageSrc: "/mocks/OVERSIZED-BOILED-WOOL-JACKET-BLACK.jpeg",
            purchasePrice: 2200,
            currency: "DEFAULT",
            properties: [
                {
                    type: "Size",
                },
                {
                    type: "Color",
                    value: "BLACK",
                },
            ],
            variants: [
                {
                    id: 4229,
                    productName: "OVERSIZED JACKET",
                    hasInventory: true,
                    properties: [
                        {
                            type: "Size",
                            value: "XS",
                        },
                    ],
                    productVariantTypeValues: ["XS"],
                },
                {
                    id: 4228,
                    productName: "OVERSIZED JACKET",
                    hasInventory: true,
                    properties: [
                        {
                            type: "Size",
                            value: "M",
                        },
                    ],
                    productVariantTypeValues: ["M"],
                },
                {
                    id: 4227,
                    productName: "OVERSIZED JACKET",
                    hasInventory: true,
                    properties: [
                        {
                            type: "Size",
                            value: "L",
                        },
                    ],
                    productVariantTypeValues: ["L"],
                },
                {
                    id: 4226,
                    productName: "OVERSIZED JACKET",
                    hasInventory: false,
                    properties: [
                        {
                            type: "Size",
                            value: "XL",
                        },
                    ],
                    productVariantTypeValues: ["XL"],
                },
            ],
        },
        {
            actualProductId: 983,
            productName: "WOOL JACKET",
            imageSrc: "/mocks/OVERSIZED-SHAWL-COLLAR-WOOL-JACKET-LIGHT-GREY.jpeg",
            purchasePrice: 2200,
            currency: "DEFAULT",
            properties: [
                {
                    type: "Size",
                },
                {
                    type: "Color",
                    value: "GREY MELANGE",
                },
            ],
            variants: [
                {
                    id: 4229,
                    productName: "WOOL JACKET",
                    hasInventory: false,
                    properties: [
                        {
                            type: "Size",
                            value: "XS",
                        },
                    ],
                    productVariantTypeValues: ["XS"],
                },
                {
                    id: 4228,
                    productName: "WOOL JACKET",
                    hasInventory: true,
                    properties: [
                        {
                            type: "Size",
                            value: "M",
                        },
                    ],
                    productVariantTypeValues: ["M"],
                },
                {
                    id: 4227,
                    productName: "WOOL JACKET",
                    hasInventory: true,
                    properties: [
                        {
                            type: "Size",
                            value: "L",
                        },
                    ],
                    productVariantTypeValues: ["L"],
                },
                {
                    id: 4226,
                    productName: "WOOL JACKET",
                    hasInventory: true,
                    properties: [
                        {
                            type: "Size",
                            value: "XL",
                        },
                    ],
                    productVariantTypeValues: ["XL"],
                },
            ],
        },

        {
            actualProductId: 984,
            productName: "WOOL JACKET",
            imageSrc: "/mocks/DOUBLE-FACED-WOOL-JACKET-BLACK.jpeg",
            purchasePrice: 1950,
            currency: "DEFAULT",
            properties: [
                {
                    type: "Size",
                },
                {
                    type: "Color",
                    value: "BLACK",
                },
            ],
            variants: [
                {
                    id: 4229,
                    productName: "WOOL JACKET",
                    hasInventory: false,
                    properties: [
                        {
                            type: "Size",
                            value: "XS",
                        },
                    ],
                    productVariantTypeValues: ["XS"],
                },
                {
                    id: 4228,
                    productName: "WOOL JACKET",
                    hasInventory: true,
                    properties: [
                        {
                            type: "Size",
                            value: "M",
                        },
                    ],
                    productVariantTypeValues: ["M"],
                },
                {
                    id: 4227,
                    productName: "WOOL JACKET",
                    hasInventory: true,
                    properties: [
                        {
                            type: "Size",
                            value: "L",
                        },
                    ],
                    productVariantTypeValues: ["L"],
                },
                {
                    id: 4226,
                    productName: "WOOL JACKET",
                    hasInventory: true,
                    properties: [
                        {
                            type: "Size",
                            value: "XL",
                        },
                    ],
                    productVariantTypeValues: ["XL"],
                },
            ],
        },
    ],
};

const productData2 = {
    product: createMockProduct({
        id: 2,
        productName: "LONG-SLEEVE TOP",
        imageSrc: "/mocks/SLIM-FIT-LONG-SLEEVE-TOP-BLACK.png",
        purchasePrice: 390,
        properties: [
            {
                type: "Color",
                value: "BLACK",
            },
            {
                type: "Size",
                value: "S",
            },
        ],
    }),
    exchangeToProductsData: {
        originalProductVariants: [
            {
                inventoryTurnr: 0,
                inventoryMerchant: 0,
                properties: [
                    {
                        type: "Color",
                        value: "BLACK",
                    },
                    {
                        type: "Size",
                        value: "XS",
                    },
                ],
            },
            {
                inventoryTurnr: 0,
                inventoryMerchant: 1,
                properties: [
                    {
                        type: "Color",
                        value: "BLACK",
                    },
                    {
                        type: "Size",
                        value: "M",
                    },
                ],
            },
            {
                inventoryTurnr: 0,
                inventoryMerchant: 0,
                properties: [
                    {
                        type: "Color",
                        value: "BLACK",
                    },
                    {
                        type: "Size",
                        value: "L",
                    },
                ],
            },
            {
                inventoryTurnr: 0,
                inventoryMerchant: 1,
                imageSrc: "/mocks/SLIM-FIT-LONG-SLEEVE-TOP-WHITE.jpeg",
                properties: [
                    {
                        type: "Color",
                        value: "WHITE",
                    },
                    {
                        type: "Size",
                        value: "XXS",
                    },
                ],
            },
            {
                inventoryTurnr: 0,
                inventoryMerchant: 1,
                imageSrc: "/mocks/SLIM-FIT-LONG-SLEEVE-TOP-WHITE.jpeg",
                properties: [
                    {
                        type: "Color",
                        value: "WHITE",
                    },
                    {
                        type: "Size",
                        value: "XS",
                    },
                ],
            },
            {
                inventoryTurnr: 0,
                inventoryMerchant: 1,
                imageSrc: "/mocks/SLIM-FIT-LONG-SLEEVE-TOP-WHITE.jpeg",
                properties: [
                    {
                        type: "Color",
                        value: "WHITE",
                    },
                    {
                        type: "Size",
                        value: "S",
                    },
                ],
            },
            {
                inventoryTurnr: 0,
                inventoryMerchant: 1,
                imageSrc: "/mocks/SLIM-FIT-LONG-SLEEVE-TOP-WHITE.jpeg",
                properties: [
                    {
                        type: "Color",
                        value: "WHITE",
                    },
                    {
                        type: "Size",
                        value: "M",
                    },
                ],
            },
            {
                inventoryTurnr: 0,
                inventoryMerchant: 1,
                imageSrc: "/mocks/SLIM-FIT-LONG-SLEEVE-TOP-WHITE.jpeg",
                properties: [
                    {
                        type: "Color",
                        value: "WHITE",
                    },
                    {
                        type: "Size",
                        value: "L",
                    },
                ],
            },
        ],
    },
    similarProducts: [
        {
            actualProductId: 982,
            productName: "MERINO WOOL TOP",
            imageSrc: "/mocks/CREW-NECK-MERINO-WOOL-TOP-OFF-WHITE.jpeg",
            purchasePrice: 550,
            currency: "DEFAULT",
            properties: [
                {
                    type: "Size",
                },
                {
                    type: "Color",
                    value: "OFF-WHITE",
                },
            ],
            variants: [
                {
                    id: 4229,
                    productName: "MERINO WOOL TOP",
                    hasInventory: true,
                    properties: [
                        {
                            type: "Size",
                            value: "XS",
                        },
                    ],
                    productVariantTypeValues: ["XS"],
                },
                {
                    id: 4228,
                    productName: "MERINO WOOL TOP",
                    hasInventory: true,
                    properties: [
                        {
                            type: "Size",
                            value: "M",
                        },
                    ],
                    productVariantTypeValues: ["M"],
                },
                {
                    id: 4227,
                    productName: "MERINO WOOL TOP",
                    hasInventory: true,
                    properties: [
                        {
                            type: "Size",
                            value: "L",
                        },
                    ],
                    productVariantTypeValues: ["L"],
                },
                {
                    id: 4226,
                    productName: "MERINO WOOL TOP",
                    hasInventory: false,
                    properties: [
                        {
                            type: "Size",
                            value: "XL",
                        },
                    ],
                    productVariantTypeValues: ["XL"],
                },
            ],
        },
    ],
};

const productData3 = {
    product: createMockProduct({
        id: 3,
        returnReasonConfig: createReturnReasonConfigStuff(),
        productName: "MOHAIR BEANIE",
        imageSrc: "/mocks/RIBBED-MOHAIR-BEANIE-LILAC.jpeg",
        purchasePrice: 450,
        properties: [
            {
                type: "Color",
                value: "LILIAC",
            },
        ],
    }),
    exchangeToProductsData: {
        originalProductVariants: [
            {
                inventoryTurnr: 0,
                inventoryMerchant: 1,
                imageSrc: "/mocks/RIBBED-MOHAIR-BEANIE-TURQUOISE.jpeg",
                properties: [
                    {
                        type: "Color",
                        value: "TURQUOISE",
                    },
                ],
            },
        ],
    },
    similarProducts: [
        {
            actualProductId: 982,
            productName: "CASHMERE BEANIE",
            imageSrc: "/mocks/PURE-CASHMERE-BEANIE-BEIGE2.jpeg",
            purchasePrice: 650,
            currency: "DEFAULT",
            properties: [
                {
                    type: "Size",
                },
                {
                    type: "Color",
                    value: "BEIGE",
                },
            ],
            variants: [
                {
                    id: 4229,
                    productName: "CASHMERE BEANIE",
                    hasInventory: true,
                    properties: [
                        {
                            type: "Color",
                            value: "BEIGE",
                        },
                    ],
                    productVariantTypeValues: ["BEIGE"],
                },
            ],
        },
        {
            actualProductId: 982,
            productName: "CASHMERE BEANIE",
            imageSrc: "/mocks/PURE-CASHMERE-BEANIE-BEIGE.jpeg",
            purchasePrice: 650,
            currency: "DEFAULT",
            properties: [
                {
                    type: "Size",
                },
                {
                    type: "Color",
                    value: "BEIGE",
                },
            ],
            variants: [
                {
                    id: 4229,
                    productName: "CASHMERE BEANIE",
                    hasInventory: true,
                    properties: [
                        {
                            type: "Color",
                            value: "BEIGE",
                        },
                    ],
                    productVariantTypeValues: ["BEIGE"],
                },
            ],
        },
        {
            actualProductId: 982,
            productName: "CASHMERE BEANIE",
            imageSrc: "/mocks/PURE-CASHMERE-BEANIE-BLACK.jpeg",
            purchasePrice: 650,
            currency: "DEFAULT",
            properties: [
                {
                    type: "Size",
                },
                {
                    type: "Color",
                    value: "BLACK",
                },
            ],
            variants: [
                {
                    id: 4229,
                    productName: "CASHMERE BEANIE",
                    hasInventory: true,
                    properties: [
                        {
                            type: "Color",
                            value: "BLACK",
                        },
                    ],
                    productVariantTypeValues: ["BLACK"],
                },
            ],
        },
    ],
};
//
// const productData5 = {
//     product: createMockProduct({
//         id: 5,
//         productName: "Teddy Vest",
//         imageSrc: "/mocks/Vest.jpeg",
//         purchasePrice: 799,
//         properties: [
//             {
//                 type: "Size",
//                 value: "S",
//             },
//             {
//                 type: "Color",
//                 value: "Beige",
//             },
//         ],
//     }),
//     exchangeToProductsData: {
//         otherProducts: [
//             createExchangeToProduct({
//                 product: createMockProduct({
//                     id: "olle",
//                     productName: "something",
//                     imageSrc: "/mocks/T-shirt.jpeg",
//                     properties: [
//                         {
//                             type: "Size",
//                             value: "S",
//                         },
//                         {
//                             type: "Color",
//                             value: "Beige",
//                         },
//                     ],
//                 }),
//                 variants: [
//                     {
//                         properties: [
//                             {
//                                 type: "Size",
//                                 value: "XS",
//                             },
//                         ],
//                     },
//                 ],
//             }),
//         ],
//     },
// };

const productsAndExchangeToProductsFn = createProductsAndExchangeToProductsFn([productData1, productData2, productData3]);

export function getExchangeToProducts({ productId }) {
    return productsAndExchangeToProductsFn.exchangeToProductsFn({ productId });
}

export function getProducts() {
    return {
        sessionId: "170bfc7b-8910-43a7-8903-52c9894ed015",
        pickupDateSelectionAllowed: true,
        shipmentSolutions: [
            {
                carrier: "BUDBEE",
                type: SHIPMENT_SOLUTION_TYPES.PICKUP.key,
                cost: 39,
            },
            {
                carrier: "POSTNORD",
                type: SHIPMENT_SOLUTION_TYPES.PRINT_LABEL.key,
                cost: 39,
            },
            {
                carrier: "COS_STORE",
                type: SHIPMENT_SOLUTION_TYPES.RETURN_IN_STORE.key,
                cost: 0,
            },
        ],
        paidShipping: 40,
        turnrShippingCost: 59,
        currencyCode: "SEK",
        refundOptions: [
            {
                type: "BASIC",
            },
            {
                type: "FAST",
                price: 29,
            },
            {
                type: "GIFT_CARD",
                bonusPercentage: 0.2,
            },
        ],
        products: productsAndExchangeToProductsFn.products,
    };
}

export function getSimilarProducts({ productId }) {
    return productsAndExchangeToProductsFn.similarProductsFn({ productId });
}
